export default function StudentCalendar(){
    return <h1>Student Calendar</h1>
}